import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";

import "../../styles/common.css";
import "../../styles/navbar.css";

import logo from "../../img/common/logo.svg";
import imgWebsite from "../../img/common/illustration_service_website.svg";
import imgMarketing from "../../img/common/illustration_service_marketing.svg";
import imgBranding from "../../img/common/illustration_service_branding.svg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <header className={`nav ${hasScrolled ? "scrolled" : ""}`}>
        <div className="nav-content">
          <div className="nav-logo">
            <a href="/en"><img src={logo} alt="LOGOT" /></a>
          </div>
          <div className="nav-right__sp">
            <div className="button-border__gray button-language nav-button button-icon sp-only">
              <a href="/"><span>JP</span></a>
            </div>
            <button
              className={`nav-toggle ${isOpen ? "open" : ""}`}
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle navigation menu"
              aria-expanded={isOpen}
              aria-controls="nav-menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={`nav-right ${isOpen ? "open" : ""}`}>
            <nav className="header-nav">
              <ul>
                <li><a href="/en/work">Portfolio</a></li>

                {!isMobile ? (
                  <li
                    className="dropdown"
                    onMouseEnter={() => {
                      clearTimeout(window.dropdownTimeout);
                      setIsDropdownOpen(true);
                    }}
                    onMouseLeave={() => {
                      window.dropdownTimeout = setTimeout(() => {
                        setIsDropdownOpen(false);
                      }, 100);
                    }}
                  >
                    <div className="dropdown-wrapper">
                      <button
                        className="dropdown-button"
                        onClick={(e) => e.preventDefault()}
                        aria-label="Services"
                      >
                        Services
                      </button>
                      {isDropdownOpen && (
                        <div className="dropdown-menu__wrapper">
                          <ul className="dropdown-menu">
                            <li>
                              <a href="/en/website">
                                <span>Website Development</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgWebsite} alt="" />
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="/en/marketing">
                                <span>Marketing Support</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgMarketing} alt="" />
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="/en/branding">
                                <span>Branding Support</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgBranding} alt="" />
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </li>
                ) : (
                  <>
                    <li><a href="/en/website">Website Development</a></li>
                    <li><a href="/en/marketing">Marketing Support</a></li>
                    <li><a href="/en/branding">Branding Support</a></li>
                  </>
                )}
                <li><a href="/en/company">About Us</a></li>
              </ul>
            </nav>
            <div className="nav-buttonArea">
              <div className="button-border__gray button-language nav-button button-icon pc-only">
                <a href="/"><span>JP</span></a>
              </div>
              <div className="button-gradation button-contact nav-button button-icon">
                <a href="/en/contact"><span>Contact Us</span></a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Container>
  );
}

export default Navbar;
